export enum FacetRefinementNames {
  DisjunctiveFacetsRefinements = 'disjunctiveFacetsRefinements',
  HierarchicalFacetsRefinements = 'hierarchicalFacetsRefinements',
  FacetsRefinements = 'facetsRefinements',
  NumericRefinements = 'numericRefinements',
}

